// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"510":"037f001c","812":"c00a5ca5"}[chunkId] + ".chunk.css";
};